import { Col, Form, Input, Row, Select, Option } from "antd";
import React, { useState } from "react";
import s from "./FullFilter.module.scss";
import {
  useGetBrandListQuery,
  useGetModelsListQuery,
} from "../../redux/apiSlice";
import useWindowDimensions from "../WindowDimensions/WindowDimensions";
import { useDispatch, useSelector } from "react-redux";
import { filterCars } from "../../redux/carSlice";
import { useTranslation } from "react-i18next";
import {
  bodyTypeOptions,
  colorsOptions,
  fuelTypesOptions,
  locationOptions,
  transmissionOptions,
  wheelOptions,
} from "../../data";

const FullFilter = () => {
  const [selectedBrand, setSelectedBrand] = useState();
  const [modelsByBrand, setModelsByBrand] = useState();
  const [modelValue, setModelValue] = useState(undefined);
  const locationList = useSelector((state) => state.cars.locations);
  const { width } = useWindowDimensions();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { data: brands } = useGetBrandListQuery();

  const currentYear = new Date().getFullYear();

  const range = (start, stop, step) =>
    Array.from(
      { length: (stop - start) / step + 1 },
      (_, i) => start + i * step
    );

  const years = range(currentYear, currentYear - 50, -1);

  const range2 = (start, stop, step) =>
    Array.from({ length: (stop - start) / step + 1 }, (_, i) =>
      (start + i * step).toFixed(1)
    );
  const fuelVolume = range2(0.1, 10, 0.1);

  const { data: models } = useGetModelsListQuery();

  const selectModels = (value) => {
    const data = models.filter((it) => it.brand.id === value);
    setModelsByBrand(data);
  };

  const findCars = async (values) => {
    const filteredCars = {
      brand: values.brand,
      model: values.model,
      year_of_manufacture_from: values.year_from,
      year_of_manufacture_till: values.year_to,
      price_from: Number(values.price_from),
      price_till: Number(values.price_to),
      fuel_type: values.fuel,
      body_type: values.type,
      steering_wheel: values.wheel,
      color: values.color,
      location: values.location,
    };

    if (filteredCars) {
      dispatch(filterCars(filteredCars));
    }
  };

  return (
    <div className={s.filters}>
      <Form form={form} className={s.form} onFinish={findCars}>
        <Row gutter={8} className={s.row}>
          <Col span={width > 800 ? 4 : 12}>
            <Form.Item name='brand'>
              <Select
                className={s.select}
                placeholder={t("brand")}
                options={brands?.map((it) => ({
                  value: it.id,
                  label: it.name,
                }))}
                value={selectedBrand}
                onSelect={(value) => {
                  setSelectedBrand(value);
                  selectModels(value);
                  setModelValue(undefined);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={width > 800 ? 4 : 12}>
            <Form.Item name='model'>
              <Select
                className={s.select}
                placeholder={t("model")}
                options={modelsByBrand?.map((it) => ({
                  value: it?.id,
                  label: it?.name,
                }))}
                value={modelValue}
                // onSelect={(value) => setModelValue(value)}
              />
            </Form.Item>
          </Col>
          <Col span={width > 800 ? 4 : 12}>
            <Form.Item name='year_from'>
              <Select
                className={s.select}
                placeholder={t("yearFrom")}
                options={years?.map((it) => ({
                  value: it,
                  label: it,
                }))}
              />
            </Form.Item>
          </Col>
          <Col span={width > 800 ? 4 : 12}>
            <Form.Item name='year_to'>
              <Select
                className={s.select}
                placeholder={t("yearTo")}
                options={years.map((it) => ({
                  value: it,
                  label: it,
                }))}
              />
            </Form.Item>
          </Col>
          <Col span={width > 800 ? 4 : 12}>
            <Form.Item name='price_from'>
              <Input placeholder={t("priceFrom")} className={s.select} />
            </Form.Item>
          </Col>
          <Col span={width > 800 ? 4 : 12}>
            <Form.Item name='price_to'>
              <Input placeholder={t("priceTo")} className={s.select} />
            </Form.Item>
          </Col>
          <Col span={width > 800 ? 4 : 12}>
            <Form.Item name='fuel'>
              <Select
                className={s.select}
                placeholder={t("fuelType")}
                options={fuelTypesOptions?.map((it) => ({
                  value: it,
                  label: t(`fuelTypeOptions.${it}`),
                }))}
              />
            </Form.Item>
          </Col>
          <Col span={width > 800 ? 4 : 12}>
            <Form.Item name='volume'>
              <Select
                className={s.select}
                placeholder={t("volumeTo")}
                options={fuelVolume?.map((it) => ({
                  value: it,
                  label: it,
                }))}
              />
            </Form.Item>
          </Col>
          <Col span={width > 800 ? 4 : 12}>
            <Form.Item name='type'>
              <Select
                className={s.select}
                placeholder={t("bodyType")}
                options={bodyTypeOptions?.map((it) => ({
                  value: it,
                  label: t(`bodyTypeOptions.${it}`),
                }))}
              />
            </Form.Item>
          </Col>
          <Col span={width > 800 ? 4 : 12}>
            <Form.Item name='wheel'>
              <Select
                className={s.select}
                placeholder={t("wheel")}
                options={wheelOptions?.map((it) => ({
                  value: it,
                  label: t(`wheelOptions.${it}`),
                }))}
              />
            </Form.Item>
          </Col>
          <Col span={width > 800 ? 4 : 12}>
            <Form.Item name='color'>
              <Select
                className={s.select}
                placeholder={t("color")}
                options={colorsOptions?.map((color) => ({
                  value: color,
                  label: t(`colors.${color}`),
                }))}
              />
            </Form.Item>
          </Col>
          <Col span={width > 800 ? 4 : 12}>
            <Form.Item name='location'>
              <Select
                className={s.select}
                placeholder={t("location")}
                options={locationOptions?.map((it) => ({
                  value: it,
                  label: t(`locationOptions.${it}`),
                }))}
              />
            </Form.Item>
          </Col>
          <Col span={width > 800 ? 4 : 12}>
            <Form.Item name='transmission'>
              <Select
                className={s.select}
                placeholder={t("transmission")}
                options={transmissionOptions?.map((it) => ({
                  value: it,
                  label: t(`transmissionOptions.${it}`),
                }))}
              />
            </Form.Item>
          </Col>
          {/* <Col span={width > 800 ? 4 : 12}>
            <Form.Item name='engine_volume'>
              <Select
                className={s.select}
                placeholder='Объем двигателя'
                options={locationList?.map((it) => ({
                  value: it?.id,
                  label: it?.name,
                }))}
              />
            </Form.Item>
          </Col> */}
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item>
              <div className={s.btns}>
                <button className={s.btn} htmlType='submit'>
                  {t("find")}
                </button>
              </div>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default FullFilter;
